window.TEV_CONFIG = {
  version: "1.0.0",
  market: "UK",
  currency: "GBP",

  ownership_periods_years: [1, 3, 5, 10],
  default_period_years: 3,

  annual_mileage_presets: [6000, 8000, 10000, 12000, 15000],
  default_annual_mileage: 10000,

  energy_prices: {
    home_electricity_per_kwh: 0.2467,
    petrol_per_litre: 1.35,
    diesel_per_litre: 1.45
  },

  charging_defaults: {
    default_mode: "home"
  },

  ved: {
    standard_annual_rate_gbp: 195,
    zero_emission_first_year_rate_gbp: 10,
    expensive_car_supplement_gbp: 425,
    expensive_car_threshold_gbp: 50000,
    expensive_car_years_applied: 5
  },

  used_age_bands: ["2_4", "5_7", "8_10"],

  comparison_modes: ["ev_vs_ice", "ev_vs_ev", "find_my_ev"]
};